import React from "react";
import ReactDOM from "react-dom/client";
import App from "./Pages/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
//import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalStyle } from "./Assets/GlobalStyle";
import { DecoratedApp } from "./Assets/HOC/DecoratedApp";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <DecoratedApp>
      {(data) => {
        return (
          <>
            <GlobalStyle />
            <App data={data} />
          </>
        );
      }}
    </DecoratedApp>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
